<form class="simple-dialog" [formGroup]="form" appFormFields>
  <div class="simple-dialog__header">
    <h2 class="simple-dialog__title">{{title}}</h2>
  </div>
  <app-form-field [name]="CreateCryptoTokenKeyField.alias"></app-form-field>
  <app-form-field [name]="CreateCryptoTokenKeyField.keySpecification"></app-form-field>
  <div class="simple-dialog__actions">
    <button type="button" mat-button
            class="simple-dialog__button"
            (click)="onCancel()">
      {{cancelText}}
    </button>
    <button type="submit" mat-button
      class="simple-dialog__button simple-dialog__button_primary"
      (click)="onSubmit()">
      {{okText}}
    </button>
  </div>
</form>
